var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip521_6939"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "expand_more_black_24dp 2",
    width: 24,
    height: 24,
    transform: "translate(0.000000 24.000000) rotate(-90.000000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "expand_more_black_24dp 2",
    width: 24,
    height: 24,
    transform: "translate(0.000000 24.000000) rotate(-90.000000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip521_6939)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.29 8.12L21.17 12L17.29 15.87C16.9 16.27 16.9 16.89 17.29 17.29C17.68 17.68 18.31 17.68 18.7 17.29L23.29 12.7C23.68 12.31 23.68 11.68 23.29 11.29L18.7 6.7C18.31 6.31 17.68 6.31 17.29 6.7C16.91 7.08 16.9 7.72 17.29 8.12Z",
    fill: "#C8C5D0",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.d70abfd4674aad7e2382bc1012e8f520.svg";
export { ForwardRef as ReactComponent };